import { numberWithSpacesToString } from '@/services/string-format.service';
import { CarFilter, PriceFilter } from '@/types/filters/filters.types';
import { atom, DefaultValue, selector } from 'recoil';

const defaultPrice: PriceFilter = {
  min: 0,
  max: 0,
};

export const searchPriceTypesState = atom<CarFilter[]>({
  key: 'searchPriceTypes',
  default: [],
});

export const searchPriceTypeSearchOptionsSelector = selector({
  key: 'searchPriceTypeSearchOptionsSelector',
  get: ({ get }) => {
    const searchPriceTypes = get(searchPriceTypesState);
    const searchPriceTypeSearchOptions: CarFilter[] = searchPriceTypes.filter(
      (option) => !option.isSelected
    );

    return { searchPriceTypeSearchOptions };
  },
});

export const priceFilterDefaultState = atom<PriceFilter>({
  key: 'priceFilterDefaultState',
  default: defaultPrice,
});

export const priceFilterState = atom<PriceFilter>({
  key: 'priceFilter',
  default: defaultPrice,
});

const selectedPriceFilterState = atom<PriceFilter>({
  key: 'selectedPriceFilterState',
  default: defaultPrice,
});

export const selectedPriceFilterSelector = selector<PriceFilter>({
  key: 'selectedPriceFilterSelector',
  get({ get }) {
    return get(selectedPriceFilterState);
  },
  set({ get, set }, price) {
    if (price instanceof DefaultValue) {
      return;
    }

    const defaultPrice = get(priceFilterDefaultState);

    if (price.min === defaultPrice.min && price.max === defaultPrice.min) {
      set(selectedPriceFilterState, { min: 0, max: 0 });
    }

    set(selectedPriceFilterState, price);
  },
});

export const hasSelectedPriceFilterSelector = selector<boolean>({
  key: 'hasSelectedPriceFilterSelector',
  get({ get }) {
    const { min, max } = get(selectedPriceFilterSelector);
    const { min: defaultMin, max: defaultMax } = get(priceFilterDefaultState);

    return min > defaultMin || (Boolean(max) && max < defaultMax);
  },
});

export const selectedPriceFilterLabelSelector = selector<string>({
  key: 'selectedPriceFilterLabelSelector',
  get({ get }) {
    const { min, max } = get(selectedPriceFilterSelector);
    const hasSelectedPriceFilter = get(hasSelectedPriceFilterSelector);

    if (hasSelectedPriceFilter) {
      return (
        'R' +
        numberWithSpacesToString(min, ' ') +
        ' - R' +
        numberWithSpacesToString(max, ' ')
      );
    }

    return '';
  },
});
